export default{
    女装: 'בגדי נשים',
    男装: 'של גברים',
    手机和小工具: 'טלפונים סלולריים וגאדג\'טים',
    居家生活: 'חיי בית',
    电脑及周边设备: 'מחשבים וציוד היקפי',
    美容及个人护理: 'יופי וטיפול אישי',
    家用电器: 'מכשירי חשמל ביתיים',
    健康与保健: 'בריאות ואיכות חיים',
    食品和饮料: 'אוכל ומשקאות',
    玩具_儿童和婴儿: 'צעצועים, ילדים ותינוקות',
    童装时尚: 'אופנת ילדים',
    视频游戏: 'משחקי וידאו',
    运动与户外: 'ספורט וחיק הטבע',
    爱好与书籍: 'תחביבים וספרים',
    相机和无人机: 'מצלמות ומזל"טים',
    宠物食品及用品: 'מזון וציוד לחיות מחמד',
    女士包袋: 'תיקי נשים',
    男士包袋: 'תיקים לגברים',
    珠宝及配饰: 'תכשיטים ואביזרים',
    手表: 'שעון',
    女鞋: 'נעליי נשים',
    男装鞋: 'נעלי גברים',
    汽车: 'אוטו',
    我附近的ShopeePay: 'ShopeePay בקרבתי',
    餐饮_旅行和服务: 'קייטרינג, נסיעות ושירותים',
    旅行及行李: 'נסיעות ומזוודות',
    各种各样的: 'סוגים שונים',
    我是来买什么的: 'מה אני כאן כדי לקנות?',
    对不起_找不到_相关的商品: 'מצטערים, לא נמצאו מוצרים הקשורים ל-[{0}]',
    类别: 'קטגוריה',
    产品: 'מוצר',
    店铺: 'לִקְנוֹת',
    首页: 'עמוד ראשי',
    限时秒杀: 'מבצע הבזק לזמן מוגבל',
    博客: 'בלוג',
    所有品牌: 'כל המותגים',
    所有类别: 'כל הקטגוריות',
    我的购物车: 'עגלת הקניות שלי',
    发货信息: 'מידע על המשלוח',
    交货信息: 'מידע על המשלוח',
    付款: 'תַשְׁלוּם',
    确认: 'לְאַשֵׁר',
    您的购物车是空的: 'עגלת הקניות שלך ריקה',
    价格: 'מחיר',
    税: 'מַס',
    数量: 'כַּמוּת',
    总计: 'סה"כ',
    移除: 'לְהַסִיר',
    返回商店: 'חזור לחנות',
    继续发货: 'המשך לשלוח',
    筛选: 'לְסַנֵן',
    价格范围: 'טווח מחירים',
    排序方式: 'מיין לפי',
    最新: 'עדכני',
    最旧: 'הוותיק ביותר',
    价格从低到高: 'מחיר מהנמוך לגבוה',
    价格从高到低: 'מחיר מהגבוה לנמוך',
    选择交货类型: 'בחר סוג משלוח',
    送货上门: 'מְסִירָה',
    继续付款: 'המשך לשלם',
    任何其他信息: 'כל מידע אחר',
    或者: 'אוֹ',
    您的钱包余额: 'יתרת הארנק שלך',
    余额不足: 'איזון לא מספיק',
    支付: 'לְשַׁלֵם',
    我同意: 'אני מסכים',
    条款和条件: 'תנאים',
    退货政策: 'מדיניות החזרה',
    隐私政策: 'מדיניות הפרטיות',
    概括: 'לְהַכלִיל',
    项目: 'פּרוֹיֶקט',
    全部的: 'את כל',
    小计: 'סכום משנה',
    总运费: 'עלות משלוח כוללת',
    有优惠码吗_在这里输入: 'יש קוד הנחה? להיכנס לכאן',
    申请: 'להגיש מועמדות',
    编辑: 'לַעֲרוֹך',
    删除: 'לִמְחוֹק',
    添加新地址: 'הוסף כתובת חדשה',
    继续交货信息: 'המשך מידע משלוח',
    选择一个地址: 'בחר כתובת',
    购买历史: 'היסטוריית רכישות',
    下载: 'הורד',
    已发送退款请求: 'נשלחה בקשה להחזר',
    对比: 'בהשוואה',
    对话: 'דו שיח',
    我的钱包: 'הארנק שלי',
    工单: 'הזמנת עבודה',
    管理个人资料: 'נהל פרופיל',
    登出: 'התנתק',
    重置对比列表: 'אפס את רשימת ההשוואה',
    您的对比列表为空: 'רשימת ההשוואות שלך ריקה',
    在您的购物车中: 'בעגלת הקניות שלך',
    在您的愿望清单中: 'ברשימת המשאלות שלך',
    在您的预定列表中: 'ברשימת ההזמנות שלך',
    下载您的产品: 'הורד את המוצר שלך',
    选项: 'אפשרויות',
    什么都没找到: 'שום דבר לא נמצא',
    特色产品: 'מוצרים מומלצים',
    最畅销: 'רב מכר',
    前_名: '{0} מובילים',
    查看更多: 'ראה עוד',
    查看所有类别: 'הצג את כל הקטגוריות',
    十大品牌: 'עשרת המותגים המובילים',
    查看所有品牌: 'הצג את כל המותגים',
    登录: 'התחברות',
    手机号码: 'מספר טלפון',
    密码: 'סיסמה',
    密码长度为6到16个字符: 'אורך הסיסמה הוא 6 עד 16 תווים',
    验证码: 'קוד אימות',
    登录中: 'התחברות',
    游客登录: 'כניסה למבקרים',
    注册您的商店: 'רשום את החנות שלך',
    现在申请: 'הגש בקשה עכשיו',
    成为商家: 'הפוך לסוחר',
    现在注册: 'הירשם עכשיו',
    登录成功: 'נחת בהצלחה',
    通知: 'לְהוֹדִיעַ',
    未找到通知: 'ההודעה לא נמצאה',
    评论: 'תגובה',
    估计运输时间: 'זמן משלוח משוער',
    天: 'שָׁמַיִם',
    所售: 'נמכר',
    给商家留言: 'השאירו הודעה לסוחר',
    规格: 'מִפרָט',
    库存: 'במלאי',
    总价: 'מחיר סופי',
    添加到购物车: 'הוסף לעגלה',
    立即购买: 'קנה את זה עכשיו',
    缺货: 'אזל במלאי',
    添加到愿望清单: 'הוסף לרשימת המשאלות',
    加入对比列表: 'הוסף לרשימת ההשוואה',
    退款: 'הֶחזֵר',
    查看条款: 'הצג תנאים',
    分享: 'לַחֲלוֹק',
    描述: 'לְתַאֵר',
    相关产品: 'מוצרים קשורים',
    没有人问过商家: 'איש לא שאל את הסוחרים',
    该产品暂无评论: 'אין עדיין ביקורות על מוצר זה',
    客户评论: 'חוות דעת של לקוחות',
    访问商店: 'בקר בחנות',
    畅销产品: 'רבי מכר',
    日期: 'תַאֲרִיך',
    订单编号: 'מספר הזמנה',
    总额: 'סְכוּם חַד פַּעַמִי',
    状态: 'מדינה',
    愿望清单: 'רשימת משאלות',
    还没有添加任何东西: 'עדיין לא התווסף כלום',
    注册: 'הירשם',
    邀请码: 'קוד הזמנה',
    请输入邀请码: 'נא להזין את קוד ההזמנה',
    用户名: 'שם משתמש',
    请输入用户名: 'נא להזין שם משתמש',
    用户名长度为6_14个字符: 'אורך שם המשתמש הוא 6-14 תווים',
    昵称: 'כינוי',
    请输入手机号码: 'נא להזין את מספר הטלפון',
    手机号码格式错误: 'פורמט שגוי של מספר הטלפון',
    密码长度为6_16个字符: 'אורך הסיסמה הוא 6-16 תווים',
    确认密码: 'אשר סיסמה',
    请输入确认密码: 'נא להזין את סיסמת האישור',
    提款密码: 'סיסמת משיכה',
    请输入提款密码: 'נא להזין את סיסמת המשיכה',
    提款密码长度为4_16个字符: 'אורך סיסמת המשיכה הוא 4-16 תווים',
    请输入验证码: 'נא להזין קוד אימות',
    在_s后发送: 'נשלח לאחר {0} שניות',
    发送验证码: 'שלח את קוד האימות',
    注册即表示您同意我们的条款和条件: 'בהרשמה אתה מסכים לתנאים וההגבלות שלנו.',
    创建账号: 'צור חשבון',
    验证码发送成功: 'קוד האימות נשלח בהצלחה',
    确认密码不一致: 'אשר שהסיסמה אינה עקבית',
    提款密码必须为数字: 'סיסמת המשיכה חייבת להיות מספרית',
    注册成功: 'הרשמה מוצלחת',
    购物车: 'עגלת קניות',
    账户: 'חֶשְׁבּוֹן',
    我的账户: 'החשבון שלי',
    已经有一个账户: 'כבר יש לך חשבון',
    新地址: 'כתובת חדשה',
    编辑地址: 'ערוך כתובת',
    保存: 'להציל',
    是否默认: 'האם זה ברירת המחדל',
    具体地址: 'כתובת ספציפית',
    请输入具体地址: 'נא להזין כתובת ספציפית',
    地区: 'אֵזוֹר',
    请输入地区: 'נא להיכנס לאזור',
    城市: 'עִיר',
    请输入城市: 'נא להיכנס לעיר',
    省份: 'מָחוֹז',
    请输入省份: 'נא להיכנס למחוז',
    邮政编码: 'מיקוד',
    请输入邮政编码: 'נא להזין מיקוד',
    电话号码: 'מספר טלפון',
    请输入电话号码: 'אנא הזן את מספר הטלפון שלך',
    收货人: 'מַקְלֵט',
    请输入收货人: 'נא להזין את הנמען',
    保存成功: 'נשמר בהצלחה',
    最畅销的商家: 'הסוחרים הנמכרים ביותר',
    查看所有的商家: 'הצג את כל העסקים',
    支持政策: 'מדיניות תמיכה',
    您的电子邮件地址: 'כתובת הדוא"ל שלך',
    订阅: 'מִנוּי',
    联系方式: 'פרטי התקשרות',
    地址: 'כתובת',
    美国伊利诺伊州霍夫曼庄园: 'הופמן אסטייטס, אילינוי, ארה"ב',
    快速链接: 'קישורים מהירים',
    商家政策: 'מדיניות סוחר',
    submit: 'שלח',
    提款银行卡: 'משיכת כרטיס בנק',
    我的面板: 'הפאנל שלי',
    提示: 'רֶמֶז',
    确定登出吗: 'האם אתה בטוח שאתה רוצה להתנתק?',
    确定: 'בטוח',
    取消: 'לְבַטֵל',
    项目添加到您的购物车: 'הוסף פריט לעגלת הקניות שלך',
    经常一起购买: 'לעתים קרובות לקנות ביחד',
    返回购物: 'חוזרים לקניות',
    进行结算: 'התקדם לנקודת הביקורת',
    帮助热线: 'קו סיוע',
    查看所有通知: 'הצג את כל ההתראות',
    请输入密码: 'נא להזין סיסמה',
    前往充值: 'לך לטעינה מחדש',
    购物车物品: 'פריטי עגלת קניות',
    查看购物车: 'לבדוק את סל הקניות',
    钱包余额: 'יתרת ארנק',
    充值钱包: 'טען את הארנק',
    钱包充值_线下_: 'טעינה מחדש של הארנק (לא מקוון)',
    申请提款: 'הגש בקשה למשיכה',
    钱包收支明细: 'פרטי הכנסות והוצאות בארנק',
    批准: 'לְאַשֵׁר',
    提现历史记录: 'היסטוריית משיכה',
    类型: 'סוּג',
    信息: 'מֵידָע',
    付款方式: 'אמצעי תשלום',
    请选择付款方式: 'אנא בחר אמצעי תשלום',
    Bill_Type_RECHARGE_BACK: 'טעינה אחורית',
    Bill_Type_RECHARGE_ONLINE: 'טעינה מקוונת',
    Bill_Type_RECHARGE_REGISTER: 'הרשם בחינם',
    Bill_Type_RECHARGE_JACKPOT: 'בונוס לטעינה',
    Bill_Type_RECHARGE_PRESENT: 'טען תגמולים מחדש',
    Bill_Type_RECHARGE_FROM_COMMISSION: 'העברת עמלה',
    Bill_Type_RECHARGE_TG_COMMISSION: 'טען עמלת קידום מחדש',
    Bill_Type_REGISTER_TG_COMMISSION: 'עמלת קידום רישום',
    Bill_Type_WITHDRAW: 'לָסֶגֶת',
    Bill_Type_WITHDRAW_REJECT: 'הנסיגה נדחתה',
    Bill_Type_DEDUCT_HANDLE: 'ניכוי ידני',
    Bill_Type_DEDUCT_RECHARGE_MONEY: 'תיקון טעינה מחדש',
    Bill_Type_MINING_PROFIT: 'הכנסה מכרייה',
    Bill_Type_MINING_PROFIT_COMMISSION: 'עמלה לקידום הכנסה בכרייה',
    Bill_Type_VIP_UPGRADE: 'שדרוג VIP',
    Bill_Type_FINANCE_BUY: 'רכישת מוצרים פיננסיים',
    Bill_Type_FINANCE_CAPITAL_RETURN: 'החזרת איזון פיננסי',
    Bill_Type_FINANCE_FEE: 'דמי ניהול פיננסיים',
    Bill_Type_FINANCE_PROFIT: 'הכנסה מניהול פיננסי',
    Bill_Type_FINANCE_BUY_COMMISSION: 'עמלה לרכישת מוצרים פיננסיים',
    Bill_Type_FINANCE_PROFIT_COMMISSION: 'עמלת הכנסה ממוצר פיננסי',
    Bill_Type_WHEEL_DRAW: 'הגרלת גלגל גדול',
    Bill_Type_BUY: 'לקנות סחורה',
    Bill_Type_PAY_SHOP: 'שלם עבור המשלוח',
    Bill_Type_BUY_COMMISSION: 'עמלה על פריטים שנרכשו',
    Bill_Type_DEPOSIT: 'שלם פיקדון',
    Bill_Type_STORE_BUY: 'לקנות סחורה',
    Bill_Type_STORE_BUY_REFUND: 'רכישת מוצר החזר כספי',
    Bill_Type: 'סוג שינוי חשבון',
    Before_Money: 'סכום קודם',
    Deal_Money: 'סכום שינוי חשבון',
    After_Money: 'כמות אחרי',
    Bill_Time: 'זמן שינוי חשבון',
    No_More_Data: 'אין יותר נתונים',
    Apply_Money: 'כמות הבקשה',
    Apply_Time: 'זמן יישום',
    Withdraw_Info: 'דמי טיפול: {fee}, הגעה: {money}',
    提款订单状态_CHECKING: 'ממתין לסקירה',
    提款订单状态_TRANSFERRING: 'מעביר',
    提款订单状态_PASS: 'מְאוּשָׁר',
    提款订单状态_REJECT: 'מְפוּטָר',
    暂无可用充值方式: 'אין עדיין שיטת טעינה זמינה',
    钱包收款码: 'קוד תשלום בארנק',
    钱包地址: 'כתובת הארנק',
    金额限制: 'מגבלת כמות',
    复制: 'עותק',
    付款凭证: 'שובר תשלום',
    收款银行: 'בנק מוטב',
    收款人: 'מקבל תשלום',
    收款账号: 'מספר חשבון תשלום',
    付款银行: 'בנק תשלומים',
    付款人: 'משלם',
    付款账号: 'חשבון תשלום',
    请输入付款银行: 'נא להזין את בנק התשלומים',
    请输入付款人: 'נא להזין את המשלם',
    请输入付款账号: 'נא להזין את מספר חשבון התשלום',
    请上传付款凭证: 'נא להעלות שובר תשלום',
    充值金额: 'כמות הטעינה מחדש',
    请输入充值金额: 'נא להזין את סכום הטעינה',
    submitting: 'הַגָשָׁה...',
    Confirm: 'שלח',
    Commit_Success: 'נשלח בהצלחה',
    balanceType_BALANCE: 'איזון',
    balanceType_COMMISSION: 'עמלה',
    Balance: 'יתרת חשבון',
    Wash_Money: 'להוסיף פסיפס',
    请选择银行账户: 'אנא בחר חשבון בנק',
    卡号类型: 'סוג מספר הכרטיס',
    提现金额: 'סכום המשיכה',
    提款金额: 'סכום המשיכה',
    不能为空: 'לא יכול להיות ריק',
    金额不正确: 'הסכום לא נכון',
    please_input_withdraw_password: 'נא להזין את סיסמת המשיכה',
    withdraw_password_format_error: 'סיסמת המשיכה חייבת להיות באורך 4-16 תווים',
    Fee: 'דמי טיפול',
    实际到账: 'הגעה בפועל',
    交易币种: "מטבע עסקה",
    原始密码: 'סיסמה מקורית',
    confirm_password_error: 'הסיסמה שהוזנה פעמיים אינה נכונה',
    save_success: 'נשמר בהצלחה',
    please_input: 'בבקשה היכנס',
    old_password: 'סיסמה ישנה',
    new_password: 'סיסמה חדשה',
    please_input_confirm_password: 'נא לאשר שוב את הסיסמה',
    没有找到符合条件的商品: 'לא נמצאו מוצרים תואמים',
    Search: 'לחפש',
    全部: 'את כל',
    EnumGoodsOrderState_USER_PAY: 'ממתין למשלוח',
    EnumGoodsOrderState_SHOP_PAY: 'מסירה',
    EnumGoodsOrderState_SUCCESS: 'סיים',
    EnumGoodsOrderState_CANCEL: 'מבוטל',
    EnumGoodsOrderState_REFUND_SUCCESS: 'הוחזר',
    订单号: 'מספר הזמנה',
    用户名称: 'שם משתמש',
    收益: 'הַכנָסָה',
    支付时间: 'זמן תשלום',
    配送时间: 'זמן משלוח',
    完成时间: 'זמן שלם',
    发货: 'ספינה',
    全选: 'בחר הכל',
    物品已添加到愿望清单: 'פריט נוסף לרשימת המשאלות',
    物品已添加到比较列表: 'פריט נוסף לרשימת ההשוואה',
    购买成功提示: 'מזל טוב, הרכישה שלך הצליחה',
    订单列表: 'רשימת הזמנות',
    商品名: 'שם מוצר',
    图片: 'תְמוּנָה',
    没有品牌: 'ללא מותג',
    基本信息: 'מידע בסיסי',
    Account_Name: 'שם פתיחת חשבון',
    Bank_Account: 'חשבון בנק',
    Bank_Phone: 'הזמן מספר טלפון נייד',
    IFSC: 'חשבון IFSC',
    UPI: 'חשבון UPI',
    PIX: 'חשבון PIX',
    CPF: 'חשבון CPF',
    GCASH: 'חשבון GCASH',
    POWWI: 'חשבון POWWI',
    身份证号: 'מספר תעודת זהות',
    Edit: 'לְשַׁנוֹת',
    Delete: 'לִמְחוֹק',
    Add: 'חָדָשׁ',
    Forget_Withdraw_Password: 'שכחת את סיסמת המשיכה',
    Bank_Card_Info: 'פרטי כרטיס בנק',
    收款人地址: 'כתובת מקבל התשלום',
    SWIFT: 'מָהִיר',
    Bank_Branch: 'שם הסניף',
    分行代码: 'קוד סניף',
    银行地址: 'כתובת בנק',
    Email: 'אימייל',
    银行卡长度必须超过: 'אורכו של כרטיס הבנק חייב לחרוג מ-{length}',
    银行卡格式不正确: 'פורמט כרטיס בנק שגוי',
    Do_you_confirm_delete: 'לאשר את המחיקה?',
    Please_Login_First: 'בבקשה התחבר קודם',
    Bank_Name: 'שם הבנק',
    Please_add_bank_first: 'עדיין לא קשרת את כרטיס הבנק שלך, אנא הוסף אותו תחילה',
    withdrawType: 'סוג משיכה',
    withdraw_money_limit: 'סכום המשיכה חייב להיות גדול מ-0 וקטן או שווה ל-{balance}',
    withdraw_times_limit: 'משכת {todayWithdrawNum} פעמים היום, ודמי טיפול בסך {withdrawFee}% יחויבו לאחר {limitTimes} פעמים. האם אתה בטוח לפרוש?',
    Copy_Success: 'הועתק בהצלחה',
    商店首页: 'דף הבית של החנות',
    所有产品: 'כל המוצרים',
    新到货产品: 'מוצרים חדשים שהגיעו',
    所有商家: 'כל הסוחרים',
    请上传: 'נא להעלות',
    请输入: 'בבקשה היכנס',
    忘记密码: 'לשכוח את הסיסמה',
    记得我: 'זכור אותי',
    共_件: 'סה"כ {0} פריטים',
    取消订单: 'בטל הזמנה',
    申请退款: 'בקש החזר',
    未知商家: 'סוחר לא ידוע',
    到账: 'קַבָּלָה',
    提款订单状态: 'מצב הזמנת משיכה',
    前_名类别: '{0} הקטגוריות המובילות',
    取消订单原因_不想要了: 'לא רוצה את זה יותר',
    取消订单原因_商品错选_多选: 'בחירת מוצר שגויה / בחירות מרובות',
    取消订单原因_商品无货: 'המוצר אזל מהמלאי',
    取消订单原因_地址信息填写错误: 'פרטי כתובת מולאו בצורה שגויה',
    取消订单原因_商品降价: 'הורדת מחיר המוצר',
    取消订单原因_价格高于其他平台: 'המחיר גבוה יותר מפלטפורמות אחרות',
    取消订单原因_没用_少用_错用优惠: 'אין שימוש/פחות שימוש/שימוש לרעה בהנחות',
    退款原因_拍错_多拍_不喜欢: 'זריקה שגויה / זריקה נוספת / לא אוהב את זה',
    退款原因_商品成分描述不符: 'תיאור מרכיב המוצר אינו תואם',
    退款原因_与商家协商一致退款: 'החזר כספי כפי שסוכם עם הסוחר',
    退款原因_生产日期_保质期与商品描述不符: 'תאריך הייצור/חיי המדף אינם תואמים את תיאור המוצר',
    退款原因_图片_产地_批号_规格等描述不符: 'תמונות/מקור המקור/מספר אצווה/מפרטים ותיאורים אחרים אינם תואמים',
    退款原因_质量问题: 'בעיות איכות',
    退款原因_商品变质_发霉_有异物: 'המוצר מקולקל/עובש/בעל חומר זר',
    退款原因_少件_含缺少配件_: 'חלקים בודדים (כולל אביזרים חסרים)',
    退款原因_收到商品时有破损_污渍_变形: 'הפריט היה פגום / מוכתם / מעוות בעת קבלתו.',
    退款原因_假冒品牌: 'מותגים מזויפים',
    退款原因_发票问题: 'בעיות חשבוניות',
    退款原因_商家发错货: 'הסוחר שלח את הסחורה הלא נכונה',
    退款原因_预约不到_商家不给退换: 'לא ניתן לקבוע תור/הסוחר לא ייתן החזרות או החלפות',
    退款失败: 'ההחזר נכשל',
    退款处理中: 'החזר מתנהל',
    默认: 'בְּרִירַת מֶחדָל',
    产品查询: 'חיפוש מוצר',
    商店LOGO: 'חנות LOGO',
    推广码: 'קוד קידום',
    查看所有: 'צפה בהכל',
    确认收货成功: 'אשר את קבלת הסחורה בהצלחה',
    物流公司: 'חברת לוגיסטיקה',
    物流单号: 'מספר משלוח',
    发货时间: 'זמן משלוח',
    请先选择商品规格: 'אנא בחר מפרט מוצר תחילה',
    个人信息: 'מידע אישי',
    您的用户名: 'שם המשתמש שלך',
    你的名字: 'השם שלך',
    登录名: 'שם משתמש',
    你的邮件: 'האימייל שלך',
    你的密码: 'הסיסמה שלך',
    重复输入密码: 'חזור על הסיסמה',
    店铺名称: 'שם חנות',
    证书类型: 'סוג אישור',
    身份证: 'תעודת זהות',
    护照: 'דַרכּוֹן',
    驾驶执照: 'רשיון נהיגה',
    社会保障卡: 'כרטיס ביטוח לאומי',
    证书正面: 'חזית תעודה',
    证书反面: 'הצד האחורי של התעודה',
    确认收货: 'לאשר את קבלת הסחורה',
    请选择取消订单的原因必选: 'אנא בחר את הסיבה לביטול ההזמנה (חובה):',
    请选择申请退款的原因必选: 'אנא בחר את הסיבה לבקשת החזר (חובה):',
    留言: 'הוֹדָעָה',
    请输入留言: 'נא להזין הודעה',
    没有帐户: 'אין חשבון',
    钱包充值: 'טעינת הארנק',
    输入您的文字: 'הזן את הטקסט שלך',
    商家登录: 'כניסה לסוחר',
    有关此产品的任何查询: 'כל שאלה לגבי מוצר זה',
    产品名称: 'שם מוצר',
    你的问题: 'בעיה שלך',
    白银店铺: 'חנות כסף',
    铂金店铺: 'חנות פלטינה',
    钻石店铺: 'חנות יהלומים',
    照片: 'תמונה',
    已退货: 'חזר',
    邮寄状态: 'סטטוס דיוור',
    订单摘要: 'סיכום הזמנה',
    收件地址: 'כתובת הנמען',
    订购日期: 'תאריך הזמנה',
    订单状态: 'מצב הזמנה',
    总订单金额: 'סכום הזמנה כולל',
    邮寄方式: 'שיטת דיוור',
    附加信息: 'מידע נוסף',
    订单详细信息: 'פרטי הזמנה',
    交货类型: 'סוג משלוח',
    进行评论: 'הגב',
    已评论: 'הגיב',
    订单金额: 'כמות הזמנה',
    优惠券: 'קוּפּוֹן',
    统一运费: 'דמי משלוח קבועים',
    送货地址: 'כתובת למשלוח',
    评分: 'ציון',
    你的意见: 'הדעה שלך',
    匿名: 'בעילום שם',
    现金: 'כסף מזומן',
    详情: 'פרטים',
    收货地址: 'כתובת למשלוח',
    暂时没有对话: 'עדיין אין שיחה',
    你: 'אתה',
    输入您的回复: 'הזן את תשובתך',
    删除成功: 'נמחק בהצלחה',
    品牌: 'מותג',
    已缴纳的保证金: 'פיקדון שולם',
    黄金店铺: 'חנות זהב',
    没有更多数据: 'אין יותר נתונים',
    站内信: 'הודעת אתר',
    系统通知: 'הודעת מערכת',
    邮箱: 'דוֹאַר',
    手机号: 'מספר טלפון',
    你的手机号: 'מספר הטלפון שלך',
    营业执照: 'רשיון עסקי',
    你的邮箱: 'תיבת הדואר שלך',
    搜索结果: 'תוצאות חיפוש',
    系统公告: 'הודעת מערכת',
    充值: 'להעלות',
    提现: 'לָסֶגֶת',
    信用分: 'דירוג אשראי',
    余额: 'איזון',
    佣金: 'עמלה',
    继续购物: 'המשך בקניות',
    订单结算: 'יישוב הזמנה',
    加入对比: 'הוסף להשוואה',
    佣金余额: "איזון עמלה",
    刷新: "לְרַעֲנֵן",
    刷新成功: "רענון מוצלח",
    官网: "אתר רשמי",
    税号: 'מספר זיהוי של מס',
    订单: 'להזמין',
    合计: "סה\"כ",
    系统安全: "אבטחת מערכת",
    Recharge_Money_Limit: 'כמות הטעינה חייבת להיות בין {min} ל-{max}',
    限时优惠: 'הצעה לזמן מוגבל',
    高价回收: 'מיחזור במחיר גבוה',
    姓名: 'שֵׁם',
    商品订单号: 'מספר הזמנה של מוצר',
    商品在线回收: 'מיחזור מוצרים באינטרנט',
    提交: 'לְהַגִישׁ',
    回收记录: 'רשומות מיחזור',
    回收状态: 'מצב מיחזור',
    回收价格: 'מחיר מיחזור',
    纳税码: 'קוד מס',
    买家登录: 'התחבר',
    买家注册: 'לִרְשׁוֹם',

    language: "希伯来语" // 以色列
};
;
